import React, { Component } from "react";
import uuid from "react-uuid";
import Comment from "../../Components/Comment/Comment";

export default class CommentList extends Component {
  render() {
    const commentsList = this.props.commentList;

    return commentsList.length
      ? commentsList.map((currVal) => <Comment CommentInfo={currVal} ItemKey={uuid()} />)
      : null;
  }
}
